module.exports = require("core-js-pure/features/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/create.js
// module id = 618
// module chunks = 0